/* eslint-disable */
import request from "./Request";

/**
 * 账号密码登录API
 * @param {object} params 参数
 * @constructor
 */


export const setNamePassword = (params: { userId: number; name: string; password: string }) =>
	request("/user", params, "PATCH", true)

export const setName = (params: { userId: number; name: string }) =>
	request("/user", params, "PATCH", true)

export const setEmail = (params: { userId: number; email: string }) =>
	request("/user", params, "PATCH", true)

export const setGoogleEmail = (params: { userId: number; code: string }) =>
	request("/user/set-google-email", params, "POST", true)

export const setPhoneNumber = (params: { userId: number; phoneNumber: string }) =>
	request("/user", params, "PATCH", true)

export const setPassword = (params: { userId: number; password: string }) =>
	request("/user", params, "PATCH", true)

export const loginByPhoneNumberCode = (params: { phoneNumber: string; code: string }) =>
	request("/auth/login-by-phone-number-code", params, "POST", true);

export const resetPasswordByPhone = (params: { phoneNumber: string; code: string; password: string }) =>
	request("/auth/reset-password-by-phone", params, "POST", true);

export const resetPasswordByEmail = (params: { email: string; code: string; password: string }) =>
	request("/auth/resetPassword", params, "POST", true);


export const getPhoneCode = (params: { phoneNumber: string }) =>
	request("/phone/send-code", params, "POST", true);


export const LoginApi = (params: { email: string; password: string }) =>
	request("/auth/login", params, "POST", true);

export const SetCompanyApi = (params: { companyId: string }) =>
	request("/auth/company", params, "POST", true);

/**
 * 注册账号API
 * @param {object} params 参数
 * @constructor
 */
export const SignUpApi = (params: {
	name: string;
	email: string;
	password: string;
}) => request("/auth/signup", params, "POST", true);


/**
 * 获取token API
 * @param {object} params 参数
 * @constructor
 */
export const GetTokenApi = (params: { code: string }) =>
	request("/auth/wechat-login", params, "POST", true);


export const GetPayUrl = (params: { cents: number }) =>
	request("/wechat-pay/pay", params, "POST", true);


export const PollingPayStatus = (params?: Partial<{
	id: string | number;
}>) =>
	request(`/wechat-pay/order/${params?.id}`, {}, "GET", true);

/**
 * 获取用户数据API
 * @param {object} params 参数
 * @constructor
 */
export const getUserApi = (params?: Partial<{ id: string }>) =>
	request("/user/me", params, "GET", true);

// 获取聊天记录列表
export const getUserAllConversationSummary = (
	params?: Partial<{
		id: string;
		type: number
	}>
) => request("/api/v1/conversations/summary", params, "GET");

// 删除聊天记录列表
export const deleteConversation = (
	params?: Partial<{
		id: string | number;
	}>
) => request(`/api/v1/conversation/${params?.id}`, params, "DELETE");

// 创建聊天记录
export const createConversation = (
	params?: Partial<{
		userId: string | number;
		title: string;
		date: string;
		deleted: boolean;
		messages: object;
	}>
) => request("/api/v1/conversation", params, "POST");

// 获取聊天记录详情
export const getConversation = (
	params?: Partial<{
		id: string | number;
	}>
) => request(`/api/v1/conversation/${params?.id}`, params, "GET");

// 附加聊天记录消息
export const appendMessage = (
	params?: Partial<{
		id: string | number;
	}>
) => request(`/api/v1/conversation/${params?.id}`, params, "PUT");

// 分片上传文件
export const uploadChunkedFile = (formData: FormData) => {
	return request(`/file/upload`, formData, "POST");
};

// 合并分片上传文件
export const mergeFile = (formData: FormData) => {
	return request(`/file/merge`, formData, "POST");
};

// 下载文件
export const downloadFile = (
	params?: Partial<{
		fileName: string;
	}>
) => request(`/file/download`, params, "GET");

const OAUTH2_REDIRECT_URI = "http://localhost:3000";

// google login
export const GoogleLoginUrl = () =>
	request(
		"/oauth2/authorize/google?redirect_uri=" + OAUTH2_REDIRECT_URI,
		{},
		"POST"
	);

export const VerifyEmailApi = (
	params: Partial<{
		email: string;
		code: string;
	}>
) => request("/auth/verify/check", params, "POST", true);

export const TriggerEmailApi = (
	params: Partial<{
		email: string;
	}>
) => request("/auth/verify/send", params, "POST", true);

export const ResetPasswordApi = (
	params: Partial<{
		email: string;
		code: string;
		password: string;
	}>
) => request("/auth/resetPassword", params, "POST");

export const GetSessionIdApi = () =>
	request("/ws-session-key/get-session-key", {}, "POST");

export const SendQAFeedback = (
	params: Partial<{
		likeDislike: number;
		context: object;
	}>
) => request("/custom-log/like-dislike", params, "POST");

// log status
export const SendStatusFeedback = (
	params: Partial<{
		status: object;
		context: object;
	}>
) => request("/custom-log/json-submit", params, "POST");

// 更多数据下载
export const GetQuote = (
	params: Partial<{
		tag: string;
		amount: number;
	}>
) => request("/api/v1/data/quote", params, "POST");

export const DownMoreData = (
	params: Partial<{
		tag?: string;
		email: string;
		amount: number;
		userPrompt?: string;
		imageUrl?: any,
		modality?: any;
		sendToDLP?: boolean;
	}>
) => request("/api/v1/data/download", params, "POST");


export const TmpUpload = (
	params: Partial<{
		tag: string;
		email: string;
		amount: number;
		userPrompt: string;
	}>
) => request("/file-upload/tmp-upload", params, "POST");
